import { useEffect } from 'react';
import { createAnalyticsEvent } from './create-analytics-event';
import { GAEventName } from './ga-event-name.enum';
import { sendRudderAnalyticsIdToBlotout } from './send-rudder-id-to-blotout';

const globalButtonClickEvent = createAnalyticsEvent<{
  clickText?: string;
  url?: string;
}>(({ clickText, url }) => ({
  event: GAEventName.BUTTON_CLICK,
  click_text: clickText,
  click_url: url
}));

export const useAnalyticGlobalEvents = () => {
  useEffect(() => {
    // Once per session send RudderStack anonymousId to Blotout
    sendRudderAnalyticsIdToBlotout();

    // button click
    const handler = (event: MouseEvent) => {
      const target = (event.target as Element).closest('a[href], button, [role=button]');
      if (!target || target.hasAttribute('data-gtm-skip-global')) {
        return;
      }
      globalButtonClickEvent({
        clickText: target.textContent?.trim() ?? target.ariaLabel ?? undefined,
        url: target.getAttribute('href') ?? undefined
      });
    };

    document.addEventListener('click', handler);
    return () => {
      document.removeEventListener('click', handler);
    };
  }, []);
};
